<div class="row document-item">
  <div class="col-5 d-flex align-items-center gap-2">
    <i
      class="fa-solid fs-4 me-2"
      [ngClass]="document.type === 'pdf' ? 'fa-file-pdf' : 'fa-file-lines'"
    ></i>
    <span
      class="fw-bold"
      baseTruncate
      >{{ document.name | baseIsEmpty }}</span
    >
  </div>
  <div class="col-3 d-flex align-items-center">
    <span>{{ document.categoryLabel | baseIsEmpty }}</span>
  </div>
  <div class="col-2 d-flex align-items-center">
    <span baseTruncate>
      {{ document.validUntil | baseFormatDate | baseIsEmpty }}
    </span>
  </div>
  <div class="col-2 d-flex gap-2 align-items-center justify-content-end">
    <base-button
      color="dark"
      icon="fa-solid fa-download"
      stateClass="pe-1"
      [iconSize]="buttonSize.md"
      (btnClick)="downloadDocument()"
    ></base-button>
    <base-button
      color="dark"
      icon="fa-solid fa-eye"
      stateClass="pe-1"
      [iconSize]="buttonSize.md"
      (btnClick)="downloadDocument(true)"
    ></base-button>
  </div>
</div>

<ng-template #documentViewerTemplate>
  <base-document-viewer
    *ngIf="document"
    [src]="activeDocumentSrc"
    [fileName]="document.originalFilename"
    [fileType]="document.type"
    [modalRef]="documentViewerModalRef"
    (downloadImage)="downloadDocument()"
  ></base-document-viewer>
</ng-template>
